<template>
  <div class="heatmap_grouping" ref="groupingWrap">
    <div class="grouping-wrap"
         ref="groupingContainer"
         @mouseenter="onSelectBoxHover(true, $event)"
         @mouseleave="onSelectBoxHover(false)"
         @mousemove="handleMouseMove($event)"
        >
      <div class="select-box"
           ref="selectBox"
           >
        <!--  coords tooltip  -->
        <transition name="coord-detail-fade">
          <div
            v-if="isHover && selectDone && selectCoords.length > 0"
            class="coord_detail"
            :class="{
              isRight: isRight && !isMouseOverBox,
              isTop: isTop && !isMouseOverBox,
              isTap: eventType === 'tap',
              isBottom: isBottom,
              insideLeft: insideLeft,
              insideRight: insideRight,
              inside: isMouseOverBox
            }"
            ref="groupTooltip"
          >
            <div class="group-tooltip-text">
              <i class="icon icon--heatmap-grouping"></i>
              <span>Group ({{ selectCoords.length }})</span>
            </div>
            <template v-if="eventType === 'click'">
              <div class="item_row_wrapper">
                <div class="item_row">
                  <span>{{ $t('common.unit.clicks') }}</span>
                  <span class="value_right">{{ calculateClickCnt | thousand }}</span>
                </div>
                <div class="item_row">
                  <span>{{ $t('common.reportIndicator.clickRate.label') }}</span>
                  <span class="value_right">{{ calculateClickRate | fixed(1) }}%</span>
                </div>
              </div>
              <div class="item_row_wrapper hrline">
                <div class="item_row">
                  <span>{{ $t('common.reportIndicator.clicksPerPv.label') }}</span>
                  <span class="value_right">{{ calculateClickPerPv | fixed(1) }}%</span>
                </div>
                <div class="item_row">
                  <span>{{ $t('common.reportIndicator.clickPvRate.label') }}</span>
                  <span class="value_right">{{ calculateClickPvRate | fixed(1) }}%</span>
                </div>
              </div>
              <div
                v-if="device === 'desktop'"
                class="item_row_wrapper hrline"
              >
                <div class="item_row">
                    <span>
                      {{ $t('heatmap.coords.hover') }}
                      <i class="icon icon--heatmap-arrow"></i>
                      {{ $t('heatmap.coords.clickRate') }}
                    </span>
                  <span class="value_right">{{ calculateHoverClickRate | fixed(1) }}%</span>
                </div>
                <div class="item_row">
                    <span>
                      {{ $t('heatmap.coords.hover') }}
                      <i class="icon icon--heatmap-arrow"></i>
                      {{ $t('heatmap.coords.clickTime') }}
                    </span>
                  <span class="value_right">{{ calculateClickTime | fixed(1) }}s</span>
                </div>
              </div>
              <i v-if="!isTop && !isMouseOverBox"
                 class="arrow-up icon bg--box-arrow-up"></i>
              <i v-if="isTop && !isMouseOverBox"
                 class="arrow-down icon bg--box-arrow-down"></i>
            </template>

            <template v-else-if="eventType === 'tap'">
              <div class="item_row_wrapper">
                <div class="item_row">
                  <span>{{ $t('common.unit.tap') }}</span>
                  <span class="value_right">{{ calculateClickCnt | thousand }}</span>
                </div>
                <div class="item_row">
                  <span>{{ $t('common.reportIndicator.tapRate.label') }}</span>
                  <span class="value_right">{{ calculateClickRate | fixed(1) }}%</span>
                </div>
              </div>
              <div class="item_row_wrapper hrline">
                <div class="item_row">
                  <span>{{ $t('common.reportIndicator.tapsPerPv.label') }}</span>
                  <span class="value_right">{{ calculateClickPerPv | fixed(1) }}%</span>
                </div>
                <div class="item_row">
                  <span>{{ $t('common.reportIndicator.tapPvRate.label') }}</span>
                  <span class="value_right">{{ calculateClickPvRate | fixed(1) }}%</span>
                </div>
              </div>
              <div class="item_row_wrapper hrline">
                <div class="item_row">
                  <span>{{ $t('common.reportIndicator.dblTapRate.label') }}</span>
                  <span class="value_right">{{ calculateDoubleTapRate | fixed(1) }}%</span>
                </div>
              </div>
            </template>
          </div>
        </transition>
      </div>
      <div
        v-for="(item, index) in coords"
        :key="index"
        class="group_rect"
        :class="{selected: selectCoords.length !== 0 && isSelectedCoords(item), hover: isHover && selectDone && isExcept === index}"
        :style="getCoordStyle(item)"
        @mouseenter="selectCoords.length !== 0 ? isExcept = index : isExcept = null"
        @mouseleave="isExcept = null"
      >
        <template v-if="isSelectedCoords(item)">
          <div
            v-if="isExcept === index && isSelectedCoords(item) && selectDone"
            :key="index"
            class="except-border"
            :style="{width: getCoordStyle(item).width, height: getCoordStyle(item).height}"
            @click.stop="removeCoords"
          >
            <svg width="100%" height="100%">
              <line x1="0" y1="0" :x2="getCoordStyle(item).width"
                    :y2="getCoordStyle(item).height"
                    style="stroke: #B6FF1B; stroke-width:2" />
            </svg>
            <svg width="100%" height="100%">
              <line x1="0" :y1="getCoordStyle(item).height"
                    :x2="getCoordStyle(item).width" y2="0"
                    style="stroke: #B6FF1B; stroke-width:2" />
            </svg>
          </div>
        </template>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'HeatmapGrouping',
  props: {
    mode: {
      type: String,
      default: 'heatmap'
    },
    coordsData: {
      type: Object,
      default: null
    },
    eventType: {
      type: String,
      default: 'click'
    },
    scale: {
      type: Number,
      default: 1
    },
    device: {
      type: String,
      default: 'desktop'
    },
    totalPv: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      coords: [],
      dragStartLeft: null,
      dragStartTop: null,
      isSelecting: false,
      selectCoords: [],
      endX: null,
      endY: null,
      isExcept: false,
      selectDone: false,
      isHover: false,
      isRight: false,
      isTop: false,
      isBottom: false,
      coordsStyle: null,
      insideRight: false,
      insideLeft: false,
      isMouseOverBox: false,
      initialSelectBoxTop: null,
      offsetX: null,
      offsetY: null
    }
  },
  computed: {
    isSelectedCoords () {
      return (item) => {
        return this.selectCoords.some(selectedBox => selectedBox.selector === item.selector)
      }
    },
    calculateClickCnt () {
      return this.selectCoords.reduce((acc, cur) => {
        if (this.eventType === 'tap') {
          return acc + cur.tapCount
        }
        return acc + cur.clickCount
      }, 0)
    },
    calculateClickRate () {
      const coords = [...this.coordsData.coordsIds.map(selector => this.coordsData.coords[selector])]
      let allCount = coords.reduce((acc, cur) => {
        if (this.eventType === 'tap') {
          return acc + cur.tapCount
        }
        return acc + cur.clickCount
      }, 0)
      return this.calculateClickCnt / allCount * 100
    },
    calculateClickPerPv () {
      return this.calculateClickCnt / this.totalPv * 100
    },
    calculateClickPvRate () {
      let result = this.selectCoords.reduce((acc, cur) => {
        if (this.eventType === 'tap') {
          return acc + cur.pvCount
        }
        return acc + cur.pvCount
      }, 0)

      result = result / this.totalPv * 100
      return result
    },
    calculateClickTime () {
      let result = this.selectCoords.reduce((acc, cur) => {
        return acc + cur.hoverClickTime
      }, 0)

      result = result / this.selectCoords.length
      return result
    },
    calculateHoverClickRate () {
      let result = this.selectCoords.reduce((acc, cur) => {
        return acc + cur.hoverCount
      }, 0)

      result = this.calculateClickCnt / result * 100
      return result
    },
    calculateDoubleTapRate () {
      // Double Tap Count / All Double Tap Count(%)
      const coords = [...this.coordsData.coordsIds.map(selector => this.coordsData.coords[selector])]
      let allDoubleTapCount = coords.reduce((acc, cur) => {
        return acc + cur.doubleTapCount
      }, 0)
      const selectDoubleTapCount = this.selectCoords.reduce((acc, cur) => {
        return acc + cur.doubleTapCount
      }, 0)
      return selectDoubleTapCount / allDoubleTapCount * 100
    }
  },
  watch: {

  },
  mounted () {
    this.onDragStart()
    this.loadCoords()
  },
  methods: {
    loadCoords () {
      if (!this.coordsData) {
        return
      }
      this.coords = this.coordsData.coordsIds.map(selector => {
        return this.coordsData.coords[selector]
      })
    },
    getCoordStyle (item) {
      return {
        top: (item.top * this.scale) + 'px',
        left: (item.left * this.scale) + 'px',
        width: (item.width * this.scale) + 'px',
        height: (item.height * this.scale) + 'px'
      }
    },
    onDragStart () {
      window.addEventListener('mousedown', (e) => {
        const parentElement = e.target.parentElement.parentElement
        const groupingWrap = this.$refs.groupingWrap
        if (parentElement.classList[0] === 'view-heatmap') {
          this.selectDone = false

          if (groupingWrap) {
            this.dragStartLeft = e.pageX - groupingWrap.getBoundingClientRect().left
            this.dragStartTop = e.pageY - groupingWrap.getBoundingClientRect().top
            this.offsetX = e.offsetX
            this.offsetY = e.offsetY

            this.$refs.selectBox.style.visibility = 'visible'

            window.addEventListener('mousemove', this.onDrag)
            window.addEventListener('mouseup', this.onDragEnd)
          }
        }
      })
    },
    onDrag (e) {
      e.preventDefault()

      const dragThreshold = 8
      if (Math.round(Math.hypot(e.offsetX - this.offsetX, e.offsetY - this.offsetY)) <= dragThreshold) {
        return
      } else {
        this.isSelecting = true
      }

      if (!this.isSelecting) return

      document.body.style.cursor = 'crosshair'
      this.$emit('onDragging', this.isSelecting)

      this.endX = e.pageX - this.$refs.groupingWrap.getBoundingClientRect().left
      this.endY = e.pageY - this.$refs.groupingWrap.getBoundingClientRect().top

      const left = this.endX < this.dragStartLeft ? this.endX : this.dragStartLeft
      const top = this.endY < this.dragStartTop ? this.endY : this.dragStartTop
      const width = Math.max(this.endX - this.dragStartLeft, this.dragStartLeft - this.endX)
      const height = Math.max(this.endY - this.dragStartTop, this.dragStartTop - this.endY)

      this.$refs.selectBox.style.left = `${left}px`
      this.$refs.selectBox.style.top = `${top}px`
      this.$refs.selectBox.style.width = `${width}px`
      this.$refs.selectBox.style.height = `${height}px`
      this.$refs.selectBox.style.border = '1px dashed #B6FF1B'

      const viewElements = document.querySelectorAll('.view')

      switch (this.mode) {
        case 'compareA':
        case 'aType':
        case 'default':
          const aView = viewElements[0].getBoundingClientRect()
          if (e.pageY > aView.bottom || e.pageY < aView.top || e.pageX > aView.right || e.pageX < aView.left) {
            this.onDragEnd()
            return
          }
          break
        case 'compareB':
        case 'bType':
          const bView = viewElements[1].getBoundingClientRect()
          if (e.pageY > bView.bottom || e.pageY < bView.top || e.pageX > bView.right || e.pageX < bView.left) {
            this.onDragEnd()
            return
          }
          break
      }

      this.updateSelection(left, top, width, height)
    },
    onDragEnd (e) {
      this.isSelecting = false

      if (this.selectCoords.length > 0) {
        this.calculateSelectBox()
      } else {
        this.$refs.selectBox.style = {
          left: 0,
          top: 0
        }
      }

      this.selectDone = true

      if (this.selectDone) {
        this.calculateTooltip()
        document.body.style.cursor = 'default'
      }

      this.$emit('onDragging', this.isSelecting)
      window.removeEventListener('mousemove', this.onDrag)
      window.removeEventListener('mouseup', this.onDragEnd)
    },
    updateSelection (left, top, width, height) {
      const selectionRect = {
        left: left,
        top: top,
        right: left + width,
        bottom: top + height
      }

      // 선택된 요소들을 추적하는 맵
      const newSelectCoords = new Set()

      this.coords.forEach((box) => {
        const boxRect = {
          left: box.left * this.scale,
          top: box.top * this.scale,
          right: (box.left + box.width) * this.scale,
          bottom: (box.top + box.height) * this.scale
        }

        const isWithinSelection = (
          boxRect.left < selectionRect.right &&
          boxRect.right > selectionRect.left &&
          boxRect.top < selectionRect.bottom &&
          boxRect.bottom > selectionRect.top
        )

        if (isWithinSelection) {
          newSelectCoords.add(box)
        }
      })

      // 이전 선택된 요소 중 새로 선택되지 않은 요소를 제거
      this.selectCoords = this.selectCoords.filter(box => newSelectCoords.has(box))

      // 새로 선택된 요소를 추가
      newSelectCoords.forEach(box => {
        if (!this.selectCoords.includes(box)) {
          this.selectCoords.push(box)
        }
      })
    },
    removeCoords (e) {
      const item = e.target
      const removeItem = item.parentElement.parentElement.classList.contains('selected') ? item.parentElement.parentElement : item.parentElement.parentElement.parentElement
      if (removeItem.classList.contains('selected')) {
        let newSelectCoords = []

        for (let i = 0; i < this.selectCoords.length; i++) {
          const selectedBox = this.selectCoords[i]

          if (selectedBox && (parseInt(selectedBox.left * this.scale) !== parseInt(removeItem.style.left) ||
              parseInt(selectedBox.top * this.scale) !== parseInt(removeItem.style.top))) {
            newSelectCoords.push(selectedBox)
          }
        }
        this.selectCoords = newSelectCoords
        this.calculateSelectBox()
      }

      if (this.selectCoords.length === 0) {
        this.$refs.selectBox.style.left = `0px`
        this.$refs.selectBox.style.top = `0px`
      }
    },
    calculateSelectBox () {
      const padding = 5
      const newSelectionRect = this.selectCoords.reduce((acc, box) => {
        const boxRect = {
          left: box.left * this.scale,
          top: box.top * this.scale,
          right: (box.left + box.width) * this.scale,
          bottom: (box.top + box.height) * this.scale
        }

        return {
          left: Math.min(acc.left, boxRect.left),
          top: Math.min(acc.top, boxRect.top),
          right: Math.max(acc.right, boxRect.right),
          bottom: Math.max(acc.bottom, boxRect.bottom)
        }
      }, {
        left: Infinity,
        top: Infinity,
        right: -Infinity,
        bottom: -Infinity
      })

      const selectBox = this.$refs.selectBox ? this.$refs.selectBox.getBoundingClientRect() : undefined
      const tooltip = this.$refs.groupTooltip
      const viewWrap = window.document.querySelector('.view-area-wrap').getBoundingClientRect()

      if (tooltip && selectBox.height > viewWrap.height && this.isMouseOverBox) {
        this.isMouseOverBox = false
        this.$refs.groupingContainer.removeEventListener('mousemove', this.handleMouseMove)
      }

      this.isHover = false
      this.$refs.selectBox.style.left = `${newSelectionRect.left - padding}px`
      this.$refs.selectBox.style.top = `${newSelectionRect.top - padding}px`
      this.$refs.selectBox.style.width = `${newSelectionRect.right - newSelectionRect.left + 2 * padding}px`
      this.$refs.selectBox.style.height = `${newSelectionRect.bottom - newSelectionRect.top + 2 * padding}px`

      if (this.selectCoords.length === 0) {
        this.$refs.selectBox.style.visibility = 'hidden'
        this.$refs.selectBox.style.width = `0px`
        this.$refs.selectBox.style.height = `0px`
      }

      this.calculateTooltip()
    },
    calculateTooltip () {
      const TOOLTIP_WIDTH = 191
      const TOOLTIP_HEIGHT = 201
      const viewHeatmap = window.document.querySelector('.view-heatmap').getBoundingClientRect()
      const selectBox = this.$refs.selectBox.getBoundingClientRect()
      const calculateRight = viewHeatmap.right - selectBox.right
      const calculateBottom = viewHeatmap.bottom - selectBox.bottom

      this.isRight = TOOLTIP_WIDTH > calculateRight
      this.isTop = TOOLTIP_HEIGHT > calculateBottom
      this.insideRight = viewHeatmap.right < selectBox.right
      this.insideLeft = viewHeatmap.left > selectBox.left && !this.isRight
    },
    onSelectBoxHover (isShow, $event) {
      this.isHover = isShow
      if (this.isHover) {
        this.updateTooltipPosition($event)
      }
    },
    handleMouseMove (e) {
      const viewWrap = window.document.querySelector('.view-area-wrap').getBoundingClientRect()
      const selectBox = this.$refs.selectBox.getBoundingClientRect()

      if (
        this.isHover &&
        (e.target.className === 'select-box' ||
          e.target.nodeName === 'svg' ||
          e.target.nodeName === 'line' ||
          e.target.className === 'group_rect selected hover') &&
        this.isHover && viewWrap.height < selectBox.height) {
        this.isMouseOverBox = true
        this.updateTooltipPosition(e)
      } else {
        this.isMouseOverBox = false
        window.removeEventListener('mousemove', this.handleMouseMove)
      }
    },
    updateTooltipPosition (e) {
      const TOOLTIP_WIDTH = 191
      const TOOLTIP_HEIGHT = 201
      const tooltip = this.$refs.groupTooltip
      const selectBoxRect = this.$refs.selectBox.getBoundingClientRect()
      const viewWrap = window.document.querySelector('.view-heatmap').getBoundingClientRect()

      const dragX = e.clientX - selectBoxRect.left
      const dragY = e.clientY - selectBoxRect.top + 10

      const right = viewWrap.right - e.pageX
      const top = viewWrap.bottom - e.pageY

      if (tooltip) {
        if (TOOLTIP_WIDTH > right) {
          tooltip.style.left = `${dragX - TOOLTIP_WIDTH}px`
        } else {
          tooltip.style.left = `${dragX}px`
        }
        if (TOOLTIP_HEIGHT > top) {
          tooltip.style.top = `${dragY - 230}px`
        } else {
          if (this.eventType === 'tap') {
            tooltip.style.top = `${dragY}px`
          }
          tooltip.style.top = `${dragY}px`
        }
      }
    }
  }
}
</script>

<style lang="scss">
.heatmap_grouping {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  .arrow-up,
  .arrow-down {
    position: absolute;
    z-index: 20;
    top: -8px;
    left: 11px;

    &.right {
      left: auto;
      right: 11px;
    }
  }
  .arrow-down {
    top: auto;
    bottom: -8px;
  }

  .group_rect {
    color: #fff;
    position: absolute;
    //border: dashed 1px #29e2ff;
    //background-color: rgba(41, 226, 255, 0.1);
    box-sizing: border-box;

    &.selected {
      border: 2px solid #B6FF1B;
      background: rgba(182, 255, 27, 0.10);

      //&.hover {
      //  border: none;
      //}
    }

    &.edit {
      border: 0px;
      padding: 2px;
      background-color: rgba(255, 245, 0, 0.3);

      &:hover {
        border-color: #ffe30d;
        background-color: rgba(255, 245, 0, 0.3);
      }
    }
  }

  .except-border {
    position: absolute;
    top: -2px;
    left: -2px;
    right: 0;
    bottom: 0;
    svg {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .coords_rect .item_row_wrapper {
    padding: 9px 0 8px 0;

    &.hrline {
      border-top: 1px solid #ebebeb;
    }

    .item_row {

      &:nth-last-of-type(1) {
        margin-top: 6px;
      }

      &::after {
        clear: both;
        display: block;
        content: "";
      }

      span {
        height: 13px;
        line-height: 1;
        display: inline-block;
        vertical-align: top;
      }

      .value_right {
        float: right;
        font-weight: 600;
      }
    }
  }
}

.coord-detail-fade-enter-active, .coord-detail-fade-leave-active {
  transition: opacity .1s ease;
}
.coord-detail-fade-enter, .coord-detail-fade-leave-to {
  opacity: 0;
}

.select-box {
  position: absolute;
  border-radius: 6px;
  background: rgba(182, 255, 27, 0.10);

  .coord_detail {
    position: absolute;
    z-index: 310;
    box-sizing: border-box;
    width: 191px;
    top: 100%;
    left: -1px;
    transform: translateY(15px);
    padding: 15px;
    white-space: nowrap;
    border-radius: 8px;
    pointer-events: none;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    font-size: 13px;
    color: #666666;

    &.isRight {
      left: auto;
      right: -1px;

      .arrow-up {
        left: auto;
        right: 7px;
      }
    }

    &.isTop {
      top: auto;
      bottom: 100%;
      transform: translateY(-15px);

      .arrow-down {
        top: 100%;
        transform: translateY(-1px);
      }

      &.isRight {
        .arrow-down {
          left: auto;
          right: 11px;
        }
      }
    }

    &.isTap {
      transform: translateY(10px);

      &.isTop {
        transform: translateY(-10px);
      }

      &.insideRight {
        left: auto;
        right: 10px;
      }

      &.insideLeft {
        left: 10px;
      }
    }

    &.insideRight {
      left: auto;
      right: 10px;
    }

    &.insideLeft {
      left: 10px;
    }

    &.inside:not(.isTap) {
      max-height: 195px;
      height: 100%;
    }

    .group-tooltip-text {
      display: flex;
      align-items: center;
      gap: 5px;
      color: #63B000;
      font-size: 13px;
      font-weight: 600;
      margin-bottom: 6px;
    }

    .item_row_wrapper {
      padding: 9px 0 8px 0;

      &.hrline {
        border-top: 1px solid #ebebeb;
      }

      &:nth-last-of-type(1) {
        padding-bottom: 0;
      }

      .item_row {

        &:nth-last-of-type(1) {
          margin-top: 6px;
        }

        &::after {
          clear: both;
          display: block;
          content: "";
        }

        span {
          height: 13px;
          line-height: 1;
          display: inline-block;
          vertical-align: top;
        }

        .value_right {
          float: right;
          font-weight: 600;
        }
      }
    }
  }

}
</style>
